/**
 * Created by hp on 2017/6/6.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router'
import { isAndroid, getJsonFromUrl, isIos } from '../utils'
import giftIconDeep from '../images/send_gift_icon-deep.png'
import DetailYX from '../images/detail_title_yx.png'
import DetailTitleTick from '../images/detail_title_tick.png'
import PurchaseNotesModal from '../components/PurchaseNotesModal'

class DetailTitle extends Component {
    constructor() {
        super()
        this.state = {
            isShowPurchaseModal: false
        }
    }

    componentDidMount () {
        if (getJsonFromUrl().share_platform === 'app') {
            this.props.dispatch({ type: 'MTA_CLICK', payload: 'app-share-show-download' })
        }
    }

    renderTitle() {
        const {detailTitle} = this.props;
        if (detailTitle.has_popular) {
            if (detailTitle.tagClass === 'single-lecture') {
                return (
                    <div className='detail-title-first-title_single'>{detailTitle.title}</div>
                )
            } else {
                return (
                    <div className='detail-title-first-title_channel-p'>{detailTitle.title}</div>
                )
            }
        } else {
            if (detailTitle.tagClass === 'single-lecture') {
                return (
                    <div className='detail-title-first-title'>{detailTitle.title}</div>
                )
            } else {
                return (
                    <div className='detail-title-first-title_channel'>{detailTitle.title}</div>
                )
            }
        }
    }

    renderPrice() {
        const {detailTitle, isHideGroupBuy} = this.props
        if (this.props.limitPrice || !detailTitle.money || (this.props.groupBuy && !isHideGroupBuy))
            return null

        if (detailTitle.original_price) {
            return <div className="detail-title-price-2">
                <span className="current-price">
                    ￥{detailTitle.money}
                </span>
                <span className="original-price">
                ￥{detailTitle.original_price}
                </span>
            </div>
        } else {
            return <div className="detail-title-info_price">
                ￥{detailTitle.money}
            </div>
        }
    }

    onClickDownload () {
        this.props.dispatch({ type: 'MTA_CLICK', payload: 'app-share-lecture-click-download' })
        if (isAndroid()) {
            location.assign('https://at.umeng.com/HPvSra')
        } else {
            location.assign('https://at.umeng.com/8D0nau')
        }
    }
    purchaseNotes() {
        this.setState({
            isShowPurchaseModal: true
        })
    }
    ClosePurchaseNotesModal() {
        this.setState({
            isShowPurchaseModal: false
        })
    }
    render() {
        const {detailTitle, complainType} = this.props
        const isFromApp = getJsonFromUrl().share_platform === 'app'
        return (
            <div>
                <div 
                    className="wk-cp-detail-title box weui-padding position-relative detail-title-global"
                    style={isFromApp ? {marginBottom: '10px', paddingBottom: '10px'} : {}}
                >
                    <div className="detail-title">
                        <div className="detail-title-first">
                            {detailTitle.has_popular && detailTitle.tagClass === 'single-lecture' &&
                            <div className="detail-title-first_yximg">
                                <img src={DetailYX}/>
                            </div>
                            }

                            {detailTitle.tagClass !== 'single-lecture' &&
                            <div className="detail-title-type-content">
                                <div className="detail-title-type">{detailTitle.type}</div>
                            </div>
                            }

                            {this.renderTitle()}
                        </div>
                        {detailTitle.subTitle.length > 0 &&
                        <div className="detail-title-subtitle">{detailTitle.subTitle}</div>
                        }
                    </div>
                    <div className="detail-title-info">
                        {Number(detailTitle.id) !== 5297593 &&
                        this.renderPrice()
                        }
                        <div className="detail-title-info_last">
                            <div className="detail-title-info_last-info">
                                <div className="detail-title-info_last-left">{detailTitle.leftSide}</div>
                                <div className="detail-title-info_last-right">{detailTitle.rightSide}</div>
                            </div>
                        </div>
                    </div>
                    {detailTitle.shouldGiftShow && false &&
                    <div className="title__float">
                        <div className="float__gift" onClick={() => detailTitle.GiftMethod()} style={isFromApp ? {bottom: '74px'} : {}}>
                            <img src="https://static-1253442168.image.myqcloud.com/picture/6031279_2b424e7b97b3f8a3d5fc7133e6a52090.jpg" alt=""/>
                            赠送好友
                        </div>
                    </div>
                    }
                    <div className="title__float">
                        <div className="float__gift" onClick={() => {location.assign(`/complain/${complainType}/${detailTitle.id}`)}} style={isFromApp ? {bottom: '74px'} : {}}>
                            <img style={{width: '12px'}} src="https://static-1253442168.file.myqcloud.com/xupload/20180704_icon-complain.png" alt="投诉"/>
                            投诉
                        </div>
                    </div>
                    {
                        isFromApp && 
                            <div className="download-app" onClick={e => this.onClickDownload()}>
                                使用APP全程回顾，永久回听
                            </div>
                        
                    }
                    
                </div>

                {/*弹出购买须知*/}
                {this.state.isShowPurchaseModal &&
                <PurchaseNotesModal ClosePurchaseNotesModal={()=>this.ClosePurchaseNotesModal()}/>
                }
                
                {
                    !isFromApp && (
                        <div className="detailtitle__bottom">
                            <div className="detailtitle__bottom-item">
                                <img src={DetailTitleTick} alt="" style={{width: '14px'}}/>
                                <span>永久回听</span>
                            </div>

                            <div className="detailtitle__bottom-item">
                                <img src={DetailTitleTick} alt="" style={{width: '14px'}}/>
                                <span>手机电脑同步听课</span>
                            </div>

                            <div className="detailtitle__bottom-item" onClick={()=> {this.purchaseNotes()}}>
                                <img src={DetailTitleTick} alt="" style={{width: '14px'}}/>
                                <span>购买须知</span>
                            </div>
                        </div>
                    )
                }

            </div>
        )
    }
}

export default connect((state) => ({
    detailTitle: state.component.detailTitle,
}))(DetailTitle);



// WEBPACK FOOTER //
// ./src/components/DetailTitle.js